export default __webpack_public_path__ + "assets/audio/1-50149108_clip.mp3";